import { render, staticRenderFns } from "./WakandaResultViewer.vue?vue&type=template&id=e4e8dd6c&scoped=true"
import script from "./WakandaResultViewer.vue?vue&type=script&lang=js"
export * from "./WakandaResultViewer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4e8dd6c",
  null
  
)

export default component.exports